export default [
    {
        name: "ID_PESSOA",
        label: "Código do Fornecedor",
        options: {
            display: "true",
            filter: true,
            download: true,
            viewColumns: false,
        },
    },
    {
        name: "NM_PESSOA",
        label: "Fornecedor",
        options: {
            display: "true",
            filter: true,
            download: true,
            viewColumns: false,
        },
    },
];
